if (!customElements.get('ap-mobile-sticky-atc')) {
  customElements.define(
    'ap-mobile-sticky-atc',
    class extends HTMLElement {
      connectedCallback() {
        this.findSourceButton = () => document.querySelector('.product__info-container product-form button[name="add"]');
        this.sourceButton = this.findSourceButton();
        this.stickyButton = this.querySelector('.ap-sticky-atc__button');
        this.price = this.querySelector('[data-ap-sticky-price]');
        this.productInfo = document.querySelector('.product__info-container');
        this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
        if (!this.sourceButton || !this.stickyButton) {
          this.hidden = true;
          return;
        }
        this.handleClick = () => this.sourceButton.click();
        this.setVisibility = (show) => {
          this.toggleAttribute('data-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          this.stickyButton.tabIndex = show ? 0 : -1;
        };
        this.updateVisibility = () => {
          const rect = this.sourceButton.getBoundingClientRect();
          this.setVisibility(rect.bottom <= 0 && this.mobileMediaQuery.matches);
        };
        this.sync = () => {
          const nextButton = this.findSourceButton();
          if (nextButton && nextButton !== this.sourceButton) {
            this.intersectionObserver?.unobserve(this.sourceButton);
            this.sourceButton = nextButton;
            this.intersectionObserver?.observe(this.sourceButton);
          }
          this.stickyButton.disabled = this.sourceButton.disabled;
          this.stickyButton.toggleAttribute('aria-disabled', this.sourceButton.disabled);
          const sourceLabel = this.sourceButton.querySelector('span');
          const stickyLabel = this.stickyButton.querySelector('span');
          if (sourceLabel && stickyLabel && this.sourceButton.disabled) stickyLabel.textContent = sourceLabel.textContent.trim();
          if (sourceLabel && stickyLabel && !this.sourceButton.disabled) stickyLabel.textContent = window.apAddToBagLabel || stickyLabel.textContent;
          const salePrice = this.productInfo?.querySelector('.price--on-sale .price-item--sale');
          const regularPrice = this.productInfo?.querySelector('.price:not(.price--on-sale) .price-item--regular');
          const activePrice = salePrice || regularPrice;
          if (activePrice && this.price) this.price.textContent = activePrice.textContent.trim();
        };
        window.apAddToBagLabel = this.stickyButton.querySelector('span')?.textContent.trim();
        this.stickyButton.addEventListener('click', this.handleClick);
        this.mutationObserver = new MutationObserver(this.sync);
        if (this.productInfo) this.mutationObserver.observe(this.productInfo, { attributes: true, childList: true, subtree: true, characterData: true });
        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0 && this.mobileMediaQuery.matches;
            this.setVisibility(show);
          },
          { root: null, threshold: 0 }
        );
        this.intersectionObserver.observe(this.sourceButton);
        this.mobileMediaQuery.addEventListener('change', this.updateVisibility);
        this.sync();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleClick);
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.mobileMediaQuery?.removeEventListener('change', this.updateVisibility);
      }
    }
  );
}

document.querySelectorAll('[data-ap-accordions]').forEach((group) => {
  group.addEventListener('toggle', (event) => {
    if (!event.target.open) return;
    group.querySelectorAll('details[open]').forEach((details) => {
      if (details !== event.target) details.removeAttribute('open');
    });
  }, true);
});
